import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import Http from './http';
var BASE_URL = 'settings/u/user';
export var API_ROUTES = {
  FETCH_PERMISSIONS: "".concat(BASE_URL, "/permissions")
};
var fetchPermissions = function fetchPermissions() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return Http.get(API_ROUTES.FETCH_PERMISSIONS, payload);
};
export default fetchPermissions;